"use strict";

var window = require("global");

module.exports.default = {
	start: noop,
	stop: noop,
	setKeepScreenOn: noop,
	setForceSpeakerphoneOn: setForceSpeakerphoneOn,
};

function setForceSpeakerphoneOn(on){
	var audioPlugin = getPlugin();
	if (!audioPlugin) return;

	var mode = on ? (
		audioPlugin.SPEAKER
	) : (
		audioPlugin.EARPIECE
	);

	audioPlugin.setAudioMode(mode);
}

function getPlugin() {
	return window.AudioToggle;
}

function noop() {}